import { render, staticRenderFns } from "./constructionRelactionTaskVendorAssess.vue?vue&type=template&id=3a29734e"
import script from "./constructionRelactionTaskVendorAssess.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskVendorAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a29734e')) {
      api.createRecord('3a29734e', component.options)
    } else {
      api.reload('3a29734e', component.options)
    }
    module.hot.accept("./constructionRelactionTaskVendorAssess.vue?vue&type=template&id=3a29734e", function () {
      api.rerender('3a29734e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskVendorAssess.vue"
export default component.exports